import React from 'react';
import NavBar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

const About = () => {
  document.title = 'About Us | Xtendliving';
  return (
    <div>
      <NavBar />
        <div className="" style={{backgroundColor: 'black', padding:50}}>
          <div className="container">
            <h4 className="white-text">Who We Are</h4>
          </div>
        </div>
        <div className="container">
          <h3 className="blue-text">Who We Are</h3>
          <p style={{color: '#6D7A8C'}}>Xtendliving combines next-generation telemedicine, telemonitoring and home health to provide you
            with immediate access to highly trained and experienced doctors and wellness experts for healthy, acute and chronic condition
            management and advice vi voice/ video calls, live chat as well as on-site doctors and clinics. You can talk to our full-time doctors
            and wellness experts from anywhere in the world, whether you are at home, at the office, on a business trip or on vacation.<br/><br/>

            Xtendliving provides consumers with a true population health management. <br /> <br />
            Our goal is to ensure appropriate balance between quality and cost, starting from the moment you access our physician helpline to the point of recovery.
          </p>
        </div>
        <div className="" style={{backgroundColor: '#F3F5F9', padding:50}}>
          <div className="container">
            <div className="section">

              <div className="row">
                <div className="col s12 m4">
                  <div className="icon-block">
                    <h2 className="center blue-text"><i class="fa fa-clock-o custom"></i></h2>
                    <h5 className="center blue-text">Truthful 24/7</h5>

                    <p className="center" style={{color: '#6D7A8C'}}>We strive to do what’s right by telling you the truth and giving you what you need, not what you can afford.</p>
                  </div>
                </div>

                <div className="col s12 m4">
                  <div className="icon-block">
                    <h2 className="center blue-text"><i class="fa fa-paste custom"></i></h2>
                    <h5 className="center blue-text">Patient-centric</h5>

                    <p className="center" style={{color: '#6D7A8C'}}>We believe that the patient always comes first. We ensure that you are truly educated about your condition and engaged in its management.</p>
                  </div>
                </div>

                <div className="col s12 m4">
                  <div className="icon-block">
                    <h2 className="center blue-text"><i class="fa fa-plus custom"></i></h2>
                    <h5 className="center blue-text">Caring</h5>

                    <p className="center" style={{color: '#6D7A8C'}}>We believe in empowering and educating patients and we provide them with round-the-clock support.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </div>
  )
}

export default About;